<template>
<div>
  <div ref="d3_root">
  </div>
</div>
</template>

<script>
import * as d3 from "d3";
export default {
  name: "ChartProportionalArea",
  props: ['height', 'width', 'text_size', 'chartData', 'render_info'],
  methods: {
    draw() {
      console.log('global max1 is ' + this.render_info.global_max_1)
      console.log('global max2 is ' + this.render_info.global_max_2)

      var max_1 = Math.ceil(this.render_info.global_max_1 )
      var axis_1 = [
          Math.ceil(max_1/4),
          Math.ceil(max_1/2),
          Math.ceil(max_1 * 0.75),
          Math.ceil(max_1)
      ]
      var max_2 = Math.ceil(this.render_info.global_max_2)
      var axis_2 = [
        Math.ceil(max_2/4),
        Math.ceil(max_2/2),
        Math.ceil(max_2 * 0.75),
        Math.ceil(max_2)
      ]

      var max_r = this.height > this.width ? this.width/2 : this.height/2

      var sqrtScale_1 = d3.scaleSqrt()
          .domain([0, max_1])
          .range([0, max_r])

      const svg_element = document.createElementNS("http://www.w3.org/2000/svg",'svg')
      const svg = d3.select(svg_element)
      var vis_1 = svg.append('g')
      var vis_2 = svg.append('g')
      this.$refs.d3_root.append(svg.node())

      // METRIC 1 -- TOP CIRCLE
      // Probably better as a loop!

      svg.append("clipPath")       // define a clip path
          .attr("id", "top-clip") // give the clipPath an ID
          .append("rect")          // shape it as a rectangle
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", "100%")
          .attr("height", this.height/2-1);

      // append the axis circles
      vis_1.append('g')
          .attr('class', 'axis-wrap')
          .selectAll('circle')
          .data(axis_1)
          .enter().append('circle')
          .attr('class', function (d) {
            return 'axis axis-' + d;
          })
          .attr('r', function (d) {
            return sqrtScale_1(d);
          })
          .attr('cx', this.width / 2)
          .attr('cy', this.height / 2)
          .style('fill', 'none')
          .style('stroke', '#aaa')
          .style('opacity', 0.5)
          .attr("clip-path", "url(#top-clip)")

      // append some axis labels
      vis_1.append('g')
          .attr('class', 'axis-labels-wrap')
          .selectAll('.axis-labels')
          .data(axis_1)
          .enter().append('text')
          .attr('x', this.width / 2)
          .attr('y', function (d) {
            return max_r - sqrtScale_1(d) + 5;
          })
          .style('text-anchor', 'middle')
          .style('fill', '#aaa')
          .text(function (d) {
              return commarize(d);
          })

      // append a circle for the value
      var area_1 = vis_1.append('circle')
          .attr('class', 'area-circle')
          .attr('cx', this.width / 2)
          .attr('cy', this.height / 2)
          .style('fill', this.chartData.metric1.color)
          .style('opacity', 0.8)
          .attr("clip-path", "url(#top-clip)")
      // append its value
      var areaLabel_1 = vis_1.append('text')
          .attr('class', 'area-label')
          .attr('x', max_r - 30)
          .attr('y', this.height / 2 - 24)
          .style('text-anchor', 'middle')
          .style('font-size', '12px')

      // METRIC 2 -- BOTTOM CIRCLE

      var sqrtScale_2 = d3.scaleSqrt()
          .domain([0, max_2])
          .range([0, max_r])

      svg.append("clipPath")       // define a clip path
          .attr("id", "bottom-clip") // give the clipPath an ID
          .append("rect")          // shape it as a rectangle
          .attr("x", 0)
          .attr("y", this.height/2+1)
          .attr("width", "100%")
          .attr("height", this.height/2);

      // append the axis circles
      vis_2.append('g')
          .attr('class', 'axis-wrap')
          .selectAll('circle')
          .data(axis_2)
          .enter().append('circle')
          .attr('class', function (d) {
            return 'axis axis-' + d;
          })
          .attr('r', function (d) {
            return sqrtScale_2(d);
          })
          .attr('cx', this.width / 2)
          .attr('cy', this.height / 2)
          .style('fill', 'none')
          .style('stroke', '#aaa')
          .style('opacity', 0.5)
          .attr("clip-path", "url(#bottom-clip)")
      // append some axis labels
      vis_2.append('g')
          .attr('class', 'axis-labels-wrap')
          .selectAll('.axis-labels')
          .data(axis_2)
          .enter().append('text')
          .attr('x', this.width / 2)
          .attr('y', function (d) {
            return max_r + sqrtScale_2(d) + 5;
          })
          .style('text-anchor', 'middle')
          .style('fill', '#aaa')
          .text(function (d) {
            return commarize(d);
          })

      // append a circle for the value
      var area_2 = vis_2.append('circle')
          .attr('class', 'area-circle')
          .attr('cx', this.width / 2)
          .attr('cy', this.height / 2)
          .style('fill', this.chartData.metric1.color)
          .style('opacity', 0.8)
          .attr("clip-path", "url(#bottom-clip)")
      // append its value
      var areaLabel_2 = vis_2.append('text')
          .attr('class', 'area-label')
          .attr('x', max_r - 30)
          .attr('y', this.height / 2 + 24)
          .style('text-anchor', 'middle')
          .style('font-size', '12px')
          .style('fill', 'white')

      // UPDATE FUNCTIONS

      function commarize(number) {
        let min = 1e3;
        // Alter numbers larger than 1k
        if (number >= min) {
          var units = ["k", "M", "B", "T", "Q"];

          var order = Math.floor(Math.log(number) / Math.log(1000));

          var unitname = units[(order - 1)];
          var num = Math.floor(number / 1000 ** order);

          // output number remainder + unitname
          return num + unitname
        }

        // return formatted original number
        return number.toLocaleString()
      }

      function update_1(val,height) {
        let r = sqrtScale_1(val)
        let comma_value = commarize(val)
        area_1.transition()
            .ease(d3.easeLinear)
            .duration(500)
            .attr('r', r)
        areaLabel_1.transition()
            .delay(100)
            .duration(500).text(comma_value)
            .style('fill', (d) => {
              return 'black'
            })
      }

      function update_2(val,height) {
        let r = sqrtScale_2(val)
        let comma_value = commarize(val)
        area_2.transition()
            .ease(d3.easeLinear)
            .duration(500)
            .attr('r', r)
        areaLabel_2.transition()
            .delay(100)
            .duration(500).text(comma_value)
            .style('fill', (d) => {
              return 'black'
            })
      }

      update_1(this.chartData.metric1.big_number_rounded,this.height)
      update_2(this.chartData.metric2.big_number_rounded,this.height)

    }
  },
  mounted() {
    if (this.chartData && this.chartData.hasOwnProperty('metric1')) this.draw(this.chartData.metric1.big_number_rounded)
  },
  watch: {
    chartData () {
      if (this.chartData && this.chartData.hasOwnProperty('metric1')) {
        this.draw(this.chartData.metric1.big_number_rounded)
      }
    }
  },
}
</script>

<style scoped>

</style>